// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3i9Eq","itemPic":"index_itemPic_1aXmt"};